import React from 'react';
import './Header.css';

function Header({ theme, onThemeToggle, user, onLogout }) {
  return (
    <header className="app-header">
      <div className="app-header__brand">
        <span className="app-header__icon">🎸</span>
        <span className="app-header__title">Chord Detector</span>
      </div>
      <div className="app-header__actions">
        {user ? <span className="app-header__user">{user.username}</span> : null}
        {user ? (
          <button className="header-button" onClick={onLogout}>Logout</button>
        ) : null}
        <button
          className="theme-toggle"
          onClick={onThemeToggle}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
      </div>
    </header>
  );
}

export default Header;
